import { render, staticRenderFns } from "./OtherCompanyConstructionEdit.vue?vue&type=template&id=1b5945be&"
import script from "./OtherCompanyConstructionEdit.vue?vue&type=script&lang=ts&"
export * from "./OtherCompanyConstructionEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports